import React, { useEffect, useState, useRef } from 'react';
import { Routes, useNavigate, useLocation } from "react-router-dom";

import routes from '../../libs/routes';
import images from "../../libs/images";
import * as API from "../../libs/service";


import { useDispatch, useSelector } from 'react-redux';

import { loadingStart, loadingEnd } from "../../redux/loadingSlice";
import { open, close } from "../../redux/popupSlice";

import Popup01 from "../../pages/popup/Popup01"

import { ToastContainer, toast, Slide, Flip, Bounce } from 'react-toastify';
import { BrowserView, MobileView, isBrowser, isMobile, isChrome, isSafari, isIOS, isAndroid } from 'react-device-detect';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Autoplay } from 'swiper/modules';



import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/autoplay';
import 'react-toastify/dist/ReactToastify.css';

import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import HLSVideo from '../../libs/hlsVideo';



const CONTENT_ITEMS = [
{
    title: { ko: '실시간 멀티 채널 UV 에디팅', en: 'Real-Time Multi-Channel UV Editing' },
    description: {
    ko: '3D 모델의 여러 UV 채널을 동시에 편집할 수 있으며, 실시간으로 결과를 확인할 수 있어 텍스처 작업을 더욱 직관적이고 효율적으로 진행할 수 있습니다.',
    en: 'Edit multiple UV channels simultaneously  and see real-time results. Optimize your texture  workflow with a more intuitive and efficient editing process.'
    },
    video: "/m3u8/uv_01.m3u8",
    thum: require("../../assets/thumnails/uv_01_thum.webp"),
    reverse: false
},
{
    title: { ko: '핫스팟 텍스처링', en: 'Hotspot Texturing' },
    description: {
    ko: '텍스처를 특정 영역에 간편하게 적용하고 수정할 수 있어 더욱 직관적이고 빠른 작업이 가능합니다. 이를 통해 사용자는 원하는 부분만 선택적으로 편집할 수 있으며, 효율적인 조정과 수정이 가능하여 전체적인 작업 속도를 크게 향상시킬 수 있습니다.',
    en: 'Apply and edit textures with precision in specific areas for a more  intuitive and faster workflow. Selectively adjust only the needed sections, enhancing efficiency and overall work speed.'
    },
    video: "/m3u8/uv_02.m3u8",
    thum: require("../../assets/thumnails/uv_02_thum.webp"),
    reverse: true
},
{
    title: { ko: 'LSCM 언랩', en: 'LSCM Unwrapping' },
    description: {
    ko: '최소한의 왜곡으로 3D 모델의 표면을 2D로 펼쳐 자연스럽게 표현할 수 있으며, 유기적인 모델에도 정밀한 맵핑이 가능합니다. 이를 통해 형태를 유지하면서도 텍스처를 손쉽게 적용할 수 있습니다.',
    en: 'Unwrap 3D surfaces into 2D with minimal distortion, ensuring natural  and precise texture mapping—even for organic models.  Maintain shape integrity while applying textures effortlessly.'
    },
    video: "/m3u8/uv_03.m3u8",
    thum: require("../../assets/thumnails/uv_03_thum.webp"),
    reverse: false
}
];


export default function UV_Editing() {
    const location = useLocation();
    
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const lang = useSelector(state => state.langReducer.lang);

    const [supBtnHover, setSupBtnHover] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    
    useEffect(() => {

    }, []);
    
    
    return (
        <>
            <div className="main_back">
                <div className="main_part padding">
                    <div className="header_page_title_box">
                        <p className="title">
                            {lang === 0 ? 'UV 에디팅' : 'UV Editing'}
                        </p>
                        <span className="sub_title">
                            {lang === 0 ? '3D를 2D로 펼쳐 정확한 텍스처 작업이 가능합니다.' : 'Unwrap 3D models into 2D with precision for flawless texture mapping.'}
                        </span>
                    </div>

                    {/* 콘텐츠 섹션 */}
                    <div className="header_page_content_box">
                        {CONTENT_ITEMS.map((item, index) => {
                        return (
                            <div className={`content ${item.reverse ? 'end' : ''}`} key={index}>
                            {item.reverse ? (
                                <>
                                <div className="title_box">
                                    <p>{lang === 0 ? item.title.ko : item.title.en}</p>
                                    <span style={{ whiteSpace: 'pre-line' }}>
                                    {lang === 0 ? item.description.ko : item.description.en}
                                    </span>
                                </div>
                                <div className="img_box">
                                    <HLSVideo
                                        width="100%"
                                        height="100%"
                                        autoPlay
                                        muted
                                        loop
                                        playsInline
                                        poster={item.thum}
                                        src={item.video}
                                    >
                                        소개 영상입니다.
                                    </HLSVideo>
                                </div>
                                </>
                            ) : (
                                <>
                                <div className="img_box">
                                    <HLSVideo
                                        width="100%"
                                        height="100%"
                                        autoPlay
                                        muted
                                        loop
                                        playsInline
                                        poster={item.thum}
                                        src={item.video}
                                    >
                                        소개 영상입니다.
                                    </HLSVideo>
                                </div>
                                <div className="title_box">
                                    <p>{lang === 0 ? item.title.ko : item.title.en}</p>
                                    <span style={{ whiteSpace: 'pre-line' }}>
                                    {lang === 0 ? item.description.ko : item.description.en}
                                    </span>
                                </div>
                                </>
                            )}
                            </div>
                        );
                        })}
                    </div>
                </div>

                <div className="page_start_banner">
                    <div className="content">
                        <p className="title">
                            {lang === 0 ? 
                                <>
                                    빠르고 편리한 UV 에디팅
                                </>
                                :
                                <>
                                    Quick & Seamless UV Editing<br /><div></div>
                                    
                                </>
                            }
                        </p>

                        <div className="btn_box">
                            <button
                                type="button"
                                className={`start ${lang === 1 ? 'eng' : ''}`}
                                style={{width: 220,}}
                                onClick={() => {
                                    navigate(routes.Price);
                                }}
                            >
                                {lang === 0 ? '무료로 써보기' : 'Try for Free'}
                            </button>
                            <button
                                type="button"
                                className={`inquiry ${lang === 1 ? 'eng' : ''}`}
                                style={{width: 220,}}
                                onClick={() => {
                                    navigate(routes.Inquiry);
                                }}
                            >
                                {lang === 0 ? '문의하기' : 'Contact Us'}
                            </button>
                        </div>
                    </div>
                </div>
                
            </div> {/* 메인 div */}

            <ToastContainer
                position="bottom-center"
                transition={Slide}
                limit={1}
                closeButton={false}
                autoClose={1000}
                style={{ width: isBrowser ? 400 : '100%', marginBottom: isBrowser ? 60 : 70 }}
                hideProgressBar
            />
        </>
    );
}
